import dayjs from 'dayjs';
import DOMPurify from 'dompurify';

export function useCsvParser() {
  async function parseCSVFile(file) {
    const Papa = await import('papaparse');
    return new Promise((resolve) => {
      Papa.parse(file, {
        header: false,
        skipEmptyLines: true,
        complete: (results) => {
          resolve(results.data);
        },
      });
    });
  }

  async function parseXlsxFile(file, options = {}) {
    const ExcelJS = await import('exceljs');

    const workbook = new ExcelJS.Workbook();
    const parsed_content = [];

    // how many separate Excel  will open when viewing
    workbook.views = [
      {
        x: 0,
        y: 0,
        width: 10000,
        height: 20000,
        firstSheet: 0,
        activeTab: 1,
        visibility: 'visible',
      },
    ];
    await new Promise((resolve) => {
      const FR = new FileReader();
      FR.onload = async (e) => {
        const data = new Uint8Array(e.target.result);

        await workbook.xlsx.load(data);

        const worksheet = workbook.worksheets[0];

        worksheet.eachRow((row) => {
          const rowData = {};
          row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            // Assuming the first row contains headers
            const headerCell = worksheet.getRow(1).getCell(colNumber);
            const headerValue = headerCell.value;
            if (headerValue) {
              if (cell.type === ExcelJS.ValueType.Hyperlink || cell.value?.hyperlink) {
                rowData[headerValue] = cell.value.text;
              }

              else if (cell.type === ExcelJS.ValueType.Formula) {
                rowData[headerValue] = cell.value.result;
              }
              else if (cell.type === ExcelJS.ValueType.Date) {
                rowData[headerValue] = dayjs(cell.value).format('YYYY-MM-DD');
              }
              else if (cell.type === ExcelJS.ValueType.Error) {
                rowData[headerValue] = '';
              }
              else {
                if (cell.value === null || cell.value === undefined) {
                  rowData[headerValue] = '';
                }
                else if (cell.value instanceof Object) {
                  rowData[headerValue] = JSON.stringify(cell.value);
                }
                else {
                  rowData[headerValue] = String(cell.value);
                }
              }
            }

            rowData[headerValue] = DOMPurify.sanitize(rowData[headerValue], { ALLOWED_TAGS: [] });
            if (options?.formatCell)
              rowData[headerValue] = options.formatCell(rowData[headerValue]);
          });
          parsed_content.push(Object.values(rowData));
        });
        resolve();
      };
      FR.readAsArrayBuffer(file);
    });
    return parsed_content;
  }

  async function parseFile(file, options = {}) {
    const file_type = file.name.split('.').pop();
    if (file_type === 'csv') {
      return parseCSVFile(file);
    }
    else if (file_type === 'xlsx') {
      return parseXlsxFile(file, options);
    }
  }

  return { parseFile };
}
